import Yup from "../yup";

const review = {
  declaration_of_truth: Yup.boolean()
    .oneOf([true], 'You must agree with the declaration of truth')
    .required('You must agree with the declaration of truth'),
};
export default review;
